"use strict";

define(['jquery', 'uiComponent', 'userlike-messenger'], function ($, Component, UserlikeMessenger) {
  'use strict';

  return Component.extend({
    /**
     * @override
     */
    initialize: function () {
      this._super();

      if (!this.widgetKey) {
        return;
      } // Load the script only after the user scrolls, moves the mouse, or touches the screen


      document.addEventListener('scroll', this.initUserlikeEvent.bind(this));
      document.addEventListener('mousemove', this.initUserlikeEvent.bind(this));
      document.addEventListener('touchstart', this.initUserlikeEvent.bind(this)); // Or, load the script after 2 seconds

      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(this.initUserlikeScript.bind(this), 2000);
      });
    },

    /**
     * Initializes the Userlike chat in response to an event
     * @param event
     */
    initUserlikeEvent: function (event) {
      this.initUserlikeScript();
      event.currentTarget.removeEventListener(event.type, this.initUserlikeScript);
    },

    /**
     * Initializes the Userlike chat
     */
    initUserlikeScript: function () {
      if (window.userlikeDidInit) {
        // Don't load again
        return false;
      }

      window.userlikeDidInit = true;
      const userlike = this.createApi();
      userlike.then(this.mount) // calls the api and loads the chat
      .then(m => m.setVisibility({
        main: false,
        // the chat is not shown
        button: false,
        // the button is not shown
        notifications: false
      })); //open the chat when el with open-chat class is clicked

      $('.open-chat').click(function (e) {
        e.preventDefault();
        userlike.then(m => m.setVisibility({
          main: true
        }));
        userlike.then(m => m.maximize());
      });
    },

    /**
     * Creates the Userlike API connection
     *
     * @returns {Promise<*>}
     */
    createApi: async function () {
      const result = await UserlikeMessenger.createMessenger({
        version: 1,
        widgetKey: this.widgetKey
      });
      const {
        api
      } = result.value;
      return api;
    },
    mount: async function (api) {
      const result = await api.mount();
      if (result.kind === "error") throw new Error(result.error);
      return api;
    }
  });
});
//# sourceMappingURL=userlike-chat.babel.js.map
